import { render, staticRenderFns } from "./ScoutResumeCardDetail.vue?vue&type=template&id=65be3e1e"
import script from "./ScoutResumeCardDetail.vue?vue&type=script&lang=js"
export * from "./ScoutResumeCardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports